import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { IUnsignedDocumentOutputModel, ResponseModel, ISaveUnSignedDocumnet } from '../Shared/interface';
import { IEmailBodyInput, ISendEmailOutput, ISendEmailInput, ISendEmailOutputModel } from '../Shared/interface2';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class UnsignedDocumentsService {
  private baseURL = this.appService.config.apiBaseUrl;

  constructor(private http: HttpClient,
              private appinsights: AppInsightsService,
              private appService: AppService) { }

    getUnsignedDocuments(unSignedDocumentInput): Observable<IUnsignedDocumentOutputModel[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/BatchUnsignedDocument/GetUnsignedDocumentForESignature`;

        return this.http.post<IUnsignedDocumentOutputModel[]>(url, unSignedDocumentInput, options)
            .pipe(
                map(res => {
                    return res as IUnsignedDocumentOutputModel[];
                }),
                catchError(this.handleError)
            );
    }

    removeUnsignedDocumentForESignature(eSignatureIds): Observable<ResponseModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/BatchUnsignedDocument/RemoveUnsignedDocumentForESignature`;

        return this.http.post(url, eSignatureIds, options)
            .pipe(
                map(res => {
                    return res as ResponseModel;
                }),
                catchError(this.handleError)
            );
    }

    saveUnsignedDocuments(unSignedDocumentInput): Observable<(ResponseModel)> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/BatchUnsignedDocument/SaveUnsignedDocumentForEsignature`;

        return this.http.post<ResponseModel>(url, unSignedDocumentInput, options)
            .pipe(
                map(res => {
                    return res as ResponseModel;
                }),
                catchError(this.handleError)
            );
    }

    getEmailBody(emailbodyinput: IEmailBodyInput): Observable<ISendEmailOutputModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/EmailAndSMS/GetBatchFollowUpEmail`;
        return this.http.post<ISendEmailOutputModel>(url, emailbodyinput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    sendEmail(emailinput: ISendEmailInput[]): Observable<ISendEmailOutput[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Email/SendEmail`;
        return this.http.post<ISendEmailOutput[]>(url, emailinput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    markPreviousUnsignedDocforDelete(leaseNo, facilityId, eSignatureId): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/BatchUnsignedDocument/MarkPreviouslyUnsignedDocforDelete?leaseNo=${leaseNo}&facilityId=${facilityId}&ESignatureId=${eSignatureId}`;
        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.log('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
